import type { PropertyTypeQuoteFormInput } from 'app/home/create-quote/forms/property-details/property-type/property-type.types';
import type { QuoteDraftSelectorState } from 'app/home/global-store/quote-draft';
import type { QuoteFormOptionsSelectorState } from 'app/home/global-store/quote-form-options';

export function propertyTypeQuoteFormSelector(store: QuoteDraftSelectorState): PropertyTypeQuoteFormInput {
  const propertyType = store.propertyType();
  return { propertyType };
}

export function propertyTypeQuoteFormOptionsSelector(store: QuoteFormOptionsSelectorState) {
  return store['property-type']();
}
